// Anuva mega menu (desktop) and mobile menu drawer.
(() => {
  if (window.__anuvaMega) return;
  window.__anuvaMega = true;

  const desktop = matchMedia('(min-width: 990px)');
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const normalize = (text) => (text || '').toLowerCase().replace(/\s+/g, ' ').trim();

  /* ---------- Desktop ---------- */
  let openPanel = null;
  let openLink = null;
  let hideTimer = null;
  const canHover = matchMedia('(hover: hover)');
  const cancelHide = () => clearTimeout(hideTimer);
  const scheduleHide = () => {
    cancelHide();
    hideTimer = setTimeout(() => hide(), 180);
  };

  const mount = () => {
    const mega = $('[data-anuva-mega]');
    const headerSection = $('header-component')?.closest('.shopify-section') || $('.header-section');
    if (mega && headerSection && mega.parentElement !== headerSection) {
      headerSection.style.position = headerSection.style.position || '';
      headerSection.appendChild(mega);
    }
    return mega;
  };

  const panelFor = (link) => {
    const label = normalize(link.textContent);
    const path = new URL(link.href, location.origin).pathname;
    return $$('.anuva-mega__panel').find((panel) => {
      const match = panel.dataset.match;
      const matchUrl = panel.dataset.matchUrl ? new URL(panel.dataset.matchUrl, location.origin).pathname : '';
      return match === label || match === label.replace(/s$/, '') || label === match.replace(/s$/, '') || (matchUrl && matchUrl === path);
    });
  };

  const show = (link, panel) => {
    if (openPanel === panel) return;
    hide(true);
    openPanel = panel;
    openLink = link;
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-open'));
    link.classList.add('is-mega-open');
    link.setAttribute('aria-expanded', 'true');
  };

  const hide = (immediate = false) => {
    if (!openPanel) return;
    const panel = openPanel;
    panel.classList.remove('is-open');
    openLink?.classList.remove('is-mega-open');
    openLink?.setAttribute('aria-expanded', 'false');
    openPanel = openLink = null;
    if (immediate) panel.hidden = true;
    else setTimeout(() => { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 250);
  };

  const initDesktop = () => {
    const mega = mount();
    if (!mega) return;
    $$('header-menu a.menu-list__link').forEach((link) => {
      const panel = panelFor(link);
      if (!panel || link.dataset.anuvaMega) return;
      link.dataset.anuvaMega = 'true';
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-controls', panel.id);
      // Hover opens the panel; a click follows the link. Touch screens: first tap opens, second tap follows.
      link.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        cancelHide();
        show(link, panel);
      });
      link.addEventListener('mouseleave', scheduleHide);
      link.addEventListener('click', (event) => {
        if (!desktop.matches || canHover.matches || openPanel === panel) return;
        event.preventDefault();
        show(link, panel);
      });
      link.addEventListener('keydown', (event) => {
        if (!desktop.matches || event.key !== ' ') return;
        event.preventDefault();
        openPanel === panel ? hide(true) : show(link, panel);
      });
    });
    // Links without a panel close any open one
    $$('header-menu a.menu-list__link:not([data-anuva-mega])').forEach((link) => {
      link.addEventListener('mouseenter', () => desktop.matches && hide(true));
    });
    mega.addEventListener('mouseenter', cancelHide);
    mega.addEventListener('mouseleave', scheduleHide);
    mega.addEventListener('focusout', (e) => {
      if (!mega.contains(e.relatedTarget) && !e.relatedTarget?.closest?.('header-menu')) hide();
    });
  };

  /* ---------- Mobile drawer ---------- */
  let lastTrigger = null;
  const drawer = () => $('#AnuvaMobileNav');
  const overlay = () => $('[data-anuva-mnav-overlay]');

  const openDrawer = (trigger) => {
    const d = drawer();
    if (!d) return false;
    if (d.parentElement !== document.body) document.body.appendChild(d);
    if (overlay().parentElement !== document.body) document.body.appendChild(overlay());
    lastTrigger = trigger;
    d.hidden = overlay().hidden = false;
    requestAnimationFrame(() => {
      d.classList.add('is-open');
      overlay().classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('anuva-mnav-open');
    try {
      const count = localStorage.getItem('wishlist_count') || '0';
      $$('[data-anuva-mnav-wishlist]').forEach((el) => (el.textContent = count));
    } catch (e) {}
    setTimeout(() => $('.anuva-mnav__close', d)?.focus(), 50);
    return true;
  };

  const closeDrawer = () => {
    const d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    overlay().classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('anuva-mnav-open');
    closeThemeDrawer();
    setTimeout(() => { d.hidden = overlay().hidden = true; }, 400);
    lastTrigger?.focus();
  };

  // Keep the theme's own menu drawer shut on phones; ours replaces it.
  const closeThemeDrawer = () => {
    document.querySelectorAll('#Details-menu-drawer-container').forEach((details) => {
      if (!details.hasAttribute('open')) return;
      details.removeAttribute('open');
      details.classList.remove('menu-open');
    });
  };

  // Take over the theme's hamburger button. Window capture runs before the theme's own handlers.
  const onTrigger = (event) => {
    const trigger = event.target.closest?.('.header__icon--menu');
    if (!trigger || desktop.matches || !drawer()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (event.type === 'click') {
      openDrawer(trigger);
      closeThemeDrawer();
    }
  };
  ['pointerdown', 'mousedown', 'touchstart'].forEach((type) =>
    window.addEventListener(type, (e) => {
      if (e.target.closest?.('.header__icon--menu') && !desktop.matches && drawer()) e.stopImmediatePropagation();
    }, { capture: true, passive: true })
  );
  window.addEventListener('click', onTrigger, true);
  window.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest?.('.header__icon--menu') && !desktop.matches && drawer()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer(e.target.closest('.header__icon--menu'));
      closeThemeDrawer();
    }
  }, true);

  const watchThemeDrawer = () => {
    document.querySelectorAll('#Details-menu-drawer-container').forEach((details) => {
      if (details.dataset.anuvaWatched) return;
      details.dataset.anuvaWatched = 'true';
      new MutationObserver(() => {
        if (!desktop.matches && details.hasAttribute('open')) closeThemeDrawer();
      }).observe(details, { attributes: true, attributeFilter: ['open'] });
    });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-anuva-mnav-close], [data-anuva-mnav-overlay]')) closeDrawer();
    if (desktop.matches && openPanel && !event.target.closest('[data-anuva-mega], header-menu')) hide();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeDrawer();
    hide(true);
  });

  // "Search categories" filters the menu list; Enter searches the store.
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-anuva-mnav-search]')) return;
    const q = normalize(event.target.value);
    const tiles = $('[data-anuva-mnav-tiles]');
    if (tiles) tiles.hidden = q.length > 0;
    $$('[data-anuva-mnav-item]').forEach((item) => {
      const hit = !q || item.dataset.search.includes(q);
      item.hidden = !hit;
      const details = $('details', item);
      if (details) details.open = Boolean(q) && hit && !normalize($('summary', item).textContent).includes(q);
    });
  });

  const init = () => {
    initDesktop();
    watchThemeDrawer();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
